import * as Diagram from "../../../../components/diagram";

export const ClosedCaseStatisticalAnalysis = {
  label: "結案統計分析",
  key: "ClosedCaseStatisticalAnalysis",
  path: "VolunteerCare/ClosedCaseStatisticalAnalysis",
  api: "TCS_V_VolunteerCare_3",
  render: (options) => (
    <Diagram.VolunteerCare.ClosedCaseStatisticalAnalysis {...options} />
  ),
  isRaw: true,
  isPage: true,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  columns: [
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證字號",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "連絡電話",
      field: "連絡電話",
      header: "連絡電話",
    },
    {
      key: "行動電話",
      field: "行動電話",
      header: "行動電話",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "個案來源",
      field: "個案來源",
      header: "個案來源",
    },
    {
      key: "開案日期",
      field: "開案日期",
      header: "開案日期",
    },
    {
      key: "結案原因",
      field: "結案原因",
      header: "結案原因",
    },
  ],
};
